// extracted by mini-css-extract-plugin
module.exports = {"container":"UG","error":"VG","disabled":"WG","jsEnabled":"XG","errorMsg":"YG"};